<template>
  <div>
    <h1 class="mb-4">Мои рецепты</h1>
    <RecipeList mode="my-recipes" />
  </div>
</template>

<script>
import RecipeList from "../RecipeList.vue";

export default {
  name: "PageMyRecipes",
  components: {
    RecipeList,
  },
};
</script>

<style scoped></style>
